import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { depositTrx, editProfileTrx, withdrawalTrx } from '../../router-translation.labels';
import { BasePageComponent } from '../base-page/base-page.component';
import { ToggleMenuBackService } from 'src/app/services/utils/toggle-menu-back.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { WithdrawalService } from 'src/app/services/payment/withdrawal/withdrawal.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent extends BasePageComponent {

  depositUrl: string = this.translationConfig.getTranslation(depositTrx);
  withdrawalUrl: string = this.translationConfig.getTranslation(withdrawalTrx);
  editProfile: string = this.translationConfig.getTranslation(editProfileTrx);

  constructor(
    private toggleBackService: ToggleMenuBackService,
    protected translationConfig: TranslationConfig,
    public detectDeviceService: DetectDeviceService,
    protected licenceService: LicenceService,
    private router: Router,
    private minimizeFotterService: MinimizeSiteService,
    private withdrawalService: WithdrawalService,
  ) { super() }

  isDesktop: boolean = this.detectDeviceService.isDesktop();
  isDeposit: boolean = true;

  ngOnInit(): void {
    // this.minimizeFotterService.minimizeToolbar();
    this.toggleBackService.showBack();
    const routeName = this.router.url.split('/').pop();
    this.isDeposit = (routeName === 'deposit' || routeName === 'wplata') ? true : false;
    this.withdrawalService.getPageTitle$.subscribe((response)=>{
      if(response){
        this.isDeposit = true;
      }
    })
  }

  switchToWithdrawal() {
    this.isDeposit = false;
  }

  switchToDeposit() {
    this.isDeposit = true;
  }
}
